module.exports = __webpack_public_path__ + "img/1724034804129-burger.jpg.9bbf2768.webp";